// Copyright 1999-2026. WebPros International GmbH. All rights reserved.

import apolloClient from 'apolloClient';

const getChildrenPath = (path, isDomainRoute) => isDomainRoute ? path : `:domainId/${path}`;

export const databaseListRoute = ({ path, createPageDataLoader, isDomainRoute = false }) => ({
    path,
    componentLoader: () => import(
        /* webpackChunkName: "components/pages/DatabasesPage" */
        'components/pages/DatabasesPage'
    ),
    loader: createPageDataLoader(),
    children: [
        {
            path: getChildrenPath('add', isDomainRoute),
            componentLoader: () => import(
                /* webpackChunkName: "components/pages/DatabasesPage/AddDatabase" */
                'components/pages/DatabasesPage/AddDatabase'
            ),
            loader: createPageDataLoader('/smb/database/create-data/domainId/:domainId'),
            handle: { isOverlay: true },
        },
        {
            path: getChildrenPath(':databaseId/connection-info', isDomainRoute),
            componentLoader: () => import(
                /* webpackChunkName: "components/pages/DatabasesPage/ConnectionInfo" */
                'components/pages/DatabasesPage/ConnectionInfo'
            ),
            loader: async ({ params }) => {
                const { data } = await apolloClient.query({
                    query: require('components/pages/DatabasesPage/ConnectionInfo.graphql'),
                    variables: { id: btoa(`Database:${params.databaseId}`) },
                });

                return data;
            },
            handle: { isOverlay: true },
        },
        {
            path: getChildrenPath(':databaseId/copy', isDomainRoute),
            componentLoader: () => import(
                /* webpackChunkName: "components/pages/DatabasesPage/CopyDatabase" */
                'components/pages/DatabasesPage/CopyDatabase'
            ),
            loader: createPageDataLoader(
                '/smb/database/clone-data/domainId/:domainId/id/:databaseId',
            ),
            handle: { isOverlay: true },
        },
        {
            path: getChildrenPath(':databaseId/import', isDomainRoute),
            componentLoader: () => import(
                /* webpackChunkName: "components/pages/DatabasesPage/ImportDatabase" */ 'components/pages/DatabasesPage/ImportDatabase'
            ),
            loader: createPageDataLoader('/smb/database/clone-data/domainId/:domainId/id/:databaseId'),
            handle: { isOverlay: true },
        },
        {
            path: getChildrenPath(':databaseId/dump', isDomainRoute),
            componentLoader: () => import(
                /* webpackChunkName: "components/pages/DatabasesPage/ExportDatabase" */ 'components/pages/DatabasesPage/ExportDatabase'
            ),
            loader: createPageDataLoader('/smb/database/clone-data/domainId/:domainId/id/:databaseId'),
            handle: { isOverlay: true },
        },
        {
            path: getChildrenPath(':databaseId/assign', isDomainRoute),
            componentLoader: () => import(
                /* webpackChunkName: "components/pages/MoveDatabasePage" */
                'components/pages/MoveDatabasePage',
            ),
            loader: async ({ params }) => {
                const { data } = await apolloClient.query({
                    query: require('queries/MoveSingleDatabasePage.graphql'),
                    variables: { databaseId: btoa(`Database:${params.databaseId}`) },
                });

                return {
                    url: '/smb/database/assign-to-subscription',
                    ids: [params.databaseId],
                    ...data,
                };
            },
            handle: { isOverlay: true },
        },
    ],
});
